import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerTimeClockPickerModalResourceBundleDe(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'de',
    'record-it-components',
    {
      dateTime: {
        TimeClockPickerModal: {
          cancel: 'Abbrechen',
          finish: 'Akzeptieren',
          next: 'Weiter',
          previous: 'Zurück'
        }
      }
    } as Partial<
      Pick<CustomTypeOptions['resources']['record-it-components'], 'dateTime'>
    >,
    true
  );
}
